export default{
  "foot": {
    "title": "لاعب Century Games",
    "p1": "أدخل معرف المستخدم الخاص بك، ادفع للشحن. سيتم تحديث المبلغ في حسابك المرتبط، إذا لم تظهر، يرجى بعد إعادة تحميل اللعبة أو التواصل مع دعم العملاء إذا لزم الأمر.",
    "p2": "إذا كان لديك أي أسئلة، لا تتردد في التواصل مع دعم العملاء. شكراً لدعمك!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "شروط الخدمة",
    "policy": "سياسة الخصوصية",
    "descriptionTitle": "كيف يعمل هذا؟"
  },
  "accept": {
    "title": "يستخدم هذا الموقع ملفات تعريف الارتباط لتحسين تجربة تصفحك. يرجى قراءة <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">سياسة الخصوصية</a> لمعرفة المعلومات حول ما نجمعه على موقعنا. من خلال الاستمرار في استخدام هذا الموقع، فإنك توافق على أننا قد نخزن ونستخدم ملفات تعريف الارتباط على جهازك.",
    "decline": "رفض",
    "accept": "قبول"
  },
  "game": {
    "inapptext": "أو تسجيل الدخول عبر اللعبة",
    "loginfail": "فشل التسجيل",
    "logintip": "إذا فشلت عملية التفويض في اللعبة، يرجى تحديث اللعبة إلى أحدث إصدار أو محاولة استخدام متصفح آخر.",
    "reloadmsg": "يرجى الضغط على زر \"إعادة التحميل\" للحصول على نتيجة تسجيل الدخول.",
    "reload": "تحديث",
    "appnotice": "إذا كنت تريد تسجيل الدخول من خلال تطبيق اللعبة، يرجى استخدام متصفح خارجي لفتح المتجر.",
    "changeaccount": "هل أنت متأكد من أنك تريد تسجيل الخروج من حسابك؟",
    "login": "تسجيل الدخول",
    "notice": "ملاحظة",
    "confirm": "تأكيد",
    "loginuserid": "معرف المستخدم",
    "palceholder": "أدخل معرف المستخدم",
    "okbtn": "حسناً",
    "loginbtn": "تسجيل الدخول عبر اللعبة",
    "changebtn": "أو تسجيل الدخول باستخدام معرف المستخدم",
    "useTitle": "الحساب",
    "checkBtn": "فحص",
    "findid": "تعذر العثور على معرف المستخدم الخاص بك؟",
    "checktext": "عادةً ما يتم العثور عليه في الإعدادات، اضغط على علامة الاستفهام للمزيد من التوجيهات.",
    "username": "اللقب:",
    "userId": "معرف المستخدم:",
    "packageTitle": "مبلغ الشحن",
    "edit": "تعديل",
    "paymentTitle": "وسيلة الدفع",
    "total": "إجمالي",
    "goPay": "ادفع الآن",
    "noSelectPackageTips": "لم تحدد أي مبلغ",
    "payFail": "فشل الدفع",
    "camelPayfail": "فشل الدفع",
    "payFailTips1": "يرجى التواصل مع دعم عملاء Adyen",
    "payFailTips2": "يرجى التواصل مع دعم العملاء Paypal",
    "paySuccess": "تم الدفع بنجاح",
    "paySuccessTips2": "أعد تحميل اللعبة أولاً قبل التواصل مع دعم العملاء لعدم استلام مشترياتك!",
    "camelPaySuccess": "تم الدفع بنجاح",
    "transactionId": "معرف المعاملة",
    "paySuccessTips": "قد يستغرق تسليم العنصر لحظة، يرجى الانتظار",
    "deliveryFail": "فشل التسليم",
    "deliveryFailTips": "يرجى التواصل مع دعم العملاء",
    "orderTitle": "ملخص طلبك",
    "paidWith": "وسيلة الدفع",
    "orderID": "معرف المعاملة",
    "payStatus": "حالة الدفع",
    "orderTotal": "السعر الإجمالي",
    "transactionDate": "تاريخ المعاملة",
    "goOnPay": "شراء مجدداً",
    "getInvoice": "فاتورة",
    "camelDeliveryFail": "فشل التسليم",
    "confirmOrder": "تأكيد الطلب",
    "confirmFollow": "يرجى تأكيد ما يلي:",
    "nickname": "اللقب",
    "packageName": "العناصر",
    "totalPayment": "السعر الإجمالي",
    "confirmPayWith": "وسيلة الدفع",
    "confirmAndGoOn": "تأكيد ومتابعة الدفع",
    "orderCancel": "إلغاء",
    "getInvoiceTitle": "إرسال عبر البريد الإلكتروني",
    "getInvoiceTips": "إذا كنت تريد تلقي الفاتورة عن طريق البريد الإلكتروني، يرجى إدخال عنوان بريد إلكتروني.",
    "getInvoiceTips1": "أدخل بريدك الإلكتروني للحصول على الفاتورة",
    "getInvoiceTips2": "وافق على جمع وتخزين عنوان بريدك الإلكتروني.",
    "getInvoiceTips3": "وافق على تلقي رسائل البريد الإلكتروني حول الخصومات والعروض الترويجية والمزيد لألعابنا عبر البريد الإلكتروني.",
    "invoiceSend": "إرسال",
    "sendSuccess": "تم إرسال الفاتورة إلى البريد الإلكتروني",
    "id404": "لم يتم العثور على معرف المستخدم",
    "packageLoadingText": "جاري تحديث عناصر المتجر...",
    "taxTips": "السعر شامل الضرائب",
    "adyenTips": "يتم توفير خدمة الدفع من قبل شركة Adyen، التي تعمل بترخيص مصرفي وتخضع للرقابة من قبل البنك المركزي الهولندي. إذا كان لديك أي استفسارات حول شهاداتها، يرجى الرجوع إلى <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. أما بالنسبة لكيفية حماية بياناتك، يرجى الرجوع إلى <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.\n",
    "paypalTips": "تتم توفير خدمة الدفع عبر PayPal. أما بالنسبة لكيفية حماية بياناتك، يرجى الرجوع إلى <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "البلد/المنطقة المفضلة لديك هي ${servercountry}. هل تريد تغيير البلد والعملة؟",
    "paypalBtn": "ادفع الآن بالبطاقة",
    "paypalOr": "أو",
    "paypalCard1": "اسم حامل البطاقة (اختياري)",
    "paypalCard2": "رقم البطاقة",
    "checkUserID": "الرابط",
    "success": "بنجاح",
    "changeCurrencyContent": "هل ترغب في تبديل المنطقة والعملة لتتناسب مع الإعداد داخل اللعبة: ${servercountry}؟",
    "productDescription": "نجوم الصقيع هذه تعادل الكاش ويمكن استخدامها لشراء أي حزم وعروض في اللعبة.",
    "payButton": "دفع",
    "userIdNotice": "يرجى إدخال معرف المستخدم الخاص بك لربط حساب اللعبة الخاص بك أولاً",
    "account": "الحساب",
    "card": "البطاقة",
    "notification": "أدخل معرف المستخدم الخاص بك لربط حسابك، وحدد العناصر التي تريدها ثم ادفع باستخدام طريقة الدفع المفضلة لديك. بعد ذلك قم بإعادة تحميل اللعبة، ستظهر العناصر المشتراة في حسابك، وستكون جاهزة للاستخدام.\n\nإذا كانت لديك أي أسئلة، فلا تتردد في التواصل مع دعم العملاء في اللعبة.",
    "rongluRank": "مستوى حجرة الاحتراق:",
    "tips": "كيف تستخدمها؟",
    "checkTIps1": "لقد قرأت وأوافق على <a :href=\"policyUrl\">\"شروط الخصوصية\"</a> و <a :href=\"serviceURl\">\"شروط الخدمة\".</a> و <a :href=\"paymentURl\">\"شروط الدفع\".</a>",
    "checkTIps2": "يرجى قراءة خانة الاختيار ووضع علامة عليها",
    "selectTips": "(العملة الخاصة بأحدث عملية شراء داخل اللعبة سيتم اختيارها.)",
    "koPayTips": "إذا كانت بطاقتك البنكية تستخدم الوون الكوري كعملة أجنبية، فسيتم استخدام خدمة تحويل العملات الديناميكي (DCC)، وقد يتم فرض رسوم إضافية من قبل طرف ثالث وسيط وليس هذا الموقع."
  },
  "invoice": {
    "title": "الفاتورة",
    "transactionId": "معرف المعاملة",
    "transactionDate": "تاريخ المعاملة",
    "totalAmount": "المبلغ الإجمالي",
    "paymentMethod": "وسيلة الدفع",
    "description": "الوصف",
    "game": "اللعبة",
    "quantity": "الكمية",
    "price": "السعر",
    "amount": "المبلغ",
    "total": "المبلغ الإجمالي",
    "footTitle": "ملاحظة",
    "footContent": "شكراً لك على دعم Century Games!",
    "button1": "احصل على الفاتورة",
    "button2": "العودة بدون فاتورة",
    "giveupInvoice": "لن تتلقى فاتورة الطلب. هل أنت متأكد؟"
  },
  "payment": {
    "card": "Credit Card / Debit Card",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "البلد / المنطقة",
    "Africa": "أفريقيا",
    "America": "أمريكا",
    "Asia": "آسيا",
    "Europe": "أوروبا",
    "Oceania": "أوقيانوسيا",
    "ZA": "جنوب أفريقيا",
    "US": "الولايات المتحدة الأمريكية",
    "HK": "هونج كونج، الصين",
    "JP": "اليابان",
    "KR": "كوريا",
    "SG": "سنغافورة",
    "SA": "المملكة العربية السعودية",
    "IQ": "العراق",
    "TW": "تايوان، الصين",
    "TH": "تايلاند",
    "GB": "المملكة المتحدة",
    "AU": "أستراليا",
    "countryLanguage1": "اللغة",
    "AE": "الإمارات العربية المتحدة",
    "DE": "ألمانيا",
    "PT": "البرتغال",
    "RU": "روسيا",
    "ES": "إسبانيا",
    "CH": "سويسرا",
    "TR": "تركيا",
    "KW": "الكويت",
    "QA": "قطر",
    "PL": "بولندا",
    "ID": "إندونيسيا",
    "IT": "إيطاليا",
    "IN": "الهند",
    "FR": "فرنسا",
    "CA": "كندا",
    "NL": "هولندا",
    "AT": "النمسا",
    "RS": "صربيا",
    "SE": "السويد",
    "MY": "ماليزيا",
    "BE": "بلجيكا",
    "DK": "الدنمارك",
    "FI": "فنلندا",
    "PH": "الفلبين",
    "NO": "النرويج",
    "BR": "البرازيل",
    "NZ": "نيوزيلندا",
    "UA": "أوكرانيا",
    "RO": "رومانيا"
  },
  "extra_info": {
    "kingdom": "المقاطعة: #"
  },
  "adyen": {
    "note": "توفر خدمة الدفع من قبل Adyen ، حيث تقدم معاملات آمنة بأعلى مستوى من شهادة PCI-DSS من منظمات بطاقات الائتمان الدولية التي تدعم مدفوعات البطاقات المحلية والخارجية.",
    "note2": "ملاحظة: ضع علامة \"حفظ للدفعة التالية\" لحفظ معلومات بطاقة الدفع الخاصة بك في متصفحك الحالي للدفعات المستقبلية."
  },
  "pay": {
    "error1": "إذا حدث خطأ ما، يرجى إعادة المحاولة لاحقاً أو استخدام وسيلة دفع أخرى. يرجى التواصل مع دعم العملاء إذا كان لديك أي أسئلة أخرى."
  }
}


// WEBPACK FOOTER //
// ./src/lang/AR.js